import {
  Box,
  Button,
  Checkbox,
  CheckboxGroup,
  Flex,
  HStack,
  Input,
  Radio,
  RadioGroup,
  Stack,
  Text,
  Textarea,
  VStack,
  useToast,
} from "@chakra-ui/react";
import { format, roundToNearestMinutes } from "date-fns";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { formatMobile, translateSMSMessage } from "../global-client";
import { getTemplates, sendSMSAction } from "../redux/actions/smsActions";

const SendSMSScreen = (route) => {
  const dispatch = useDispatch();
  const { templates } = useSelector((state) => state.smsTemplate);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [smsPreview, setSmsPreview] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const { toNumber, fName, sName, jobNo, jobId, custId, itemName, total, balance, eta } = location.state || {};
  const [delaySelected, setDelaySelected] = useState("1");
  const [smsDelayMinutes, setSmsDelayMinutes] = useState(30);
  //const [smsScheduleTime, setSmsScheduleTime] = useState(new Date(Date.now() + 15 * 60000)); // Default to 15 minutes from now
  const [smsScheduleTime, setSmsScheduleTime] = useState(
    roundToNearestMinutes(new Date(), { roundingMethod: "ceil", nearestTo: 30 })
  ); // Default to next closest 30 minutes
  const [completeFlag, setCompleteFlag] = useState(false);
  const [pickedupFlag, setPickedupFlag] = useState(false);
  const [irreparableFlag, setIrreparableFlag] = useState(false);
  const [removeFlag, setRemoveFlag] = useState(false);
  const [confirmFlag, setConfirmFlag] = useState(false);
  const [unconfirmFlag, setUnconfirmFlag] = useState(false);
  const [cancelFlag, setCancelFlag] = useState(false);

  const toast = useToast();

  //console.log("SendSMSScreen route.state: ", location.state);

  const handleInputChange = (e) => {
    setSmsPreview(e.target.value);
  };

  useEffect(() => {
    dispatch(getTemplates());
  }, [dispatch]);

  const handleTemplateSelect = (template) => {
    setSelectedTemplate(template);
    setCompleteFlag(template.AC_COMPLETE === 1);
    setPickedupFlag(template.AC_PICKEDUP === 1);
    setIrreparableFlag(template.AC_IRREPARABLE === 1);
    setRemoveFlag(template.AC_REMOVE === 1);
    setConfirmFlag(template.AC_CONFIRM === 1);
    setUnconfirmFlag(template.AC_UNCONFIRM === 1);
    setCancelFlag(template.AC_CANCEL === 1);
    setSmsPreview(translateSMSMessage(template.SAVEDSMSMESS_TEXT, fName, sName, jobNo, itemName, total, balance, eta));
  };

  const handleSendSMS = () => {
    // Implement SMS sending logic here
    // You can use the selectedTemplate, smsPreview, delaySelected, smsDelayMinutes, smsScheduleTime, and flags as needed
    let timeToSend = new Date();
    if (delaySelected === "3") {
      timeToSend = smsScheduleTime;
    } else {
      if (delaySelected === "2") {
        timeToSend = new Date(Date.now() + Number(smsDelayMinutes) * 60000);
      }
    }

    const smsData = {
      from: "+61407103182", // Your Twilio number
      to: toNumber,
      body: smsPreview,
      delayOption: delaySelected,
      delayMinutes: smsDelayMinutes,
      scheduledTime: timeToSend,
      jobId: jobId,
      jobNo: jobNo,
      custId: custId,
      custName: fName + " " + sName,
      flags: {
        complete: completeFlag,
        pickedup: pickedupFlag,
        irreparable: irreparableFlag,
        remove: removeFlag,
        confirm: confirmFlag,
        unconfirm: unconfirmFlag,
        cancel: cancelFlag,
      },
    };

    //console.log("SMS Data to be sent:", smsData);
    dispatch(sendSMSAction(smsData));
    toast({
      title: "SMS to " + formatMobile(toNumber),
      description:
        smsData.delayOption === "1"
          ? "The SMS has been sent successfully."
          : "The SMS has been scheduled successfully.",
      status: "success",
      duration: 5000,
      isClosable: true,
    });

    navigate(-1);
  };

  return (
    <>
      <Flex direction={{ base: "column", md: "row" }} mx={{ base: 2, md: 8 }} my={8} gap={8}>
        {/* Templates List */}
        <VStack
          boxShadow='xl'
          w={{ base: "100%", md: "32%" }}
          maxH={{ base: "50vh", md: "80vh" }}
          spacing={2}
          align='stretch'
        >
          <Box
            bg='gray.200'
            p={5}
            borderTopRadius='lg'
            w='100%'
            display='flex'
            flexDirection='column'
            alignItems='center'
          >
            <Text fontSize='xl' fontWeight='bold' color='blue.700'>
              SMS Templates
            </Text>
            {/* <Button variant='link' onClick={() => dispatch(getTemplates())} mr='4'>
              &#x21bb; Refresh
            </Button> */}
          </Box>
          <Box bg='white' p={6} borderBottomRadius='lg' boxShadow='xl' overflowY='auto'>
            {templates && templates.length > 0 ? (
              <Stack w='100%' spacing={2}>
                <Box
                  key={"0000"}
                  p={1}
                  borderRadius='lg'
                  borderWidth={selectedTemplate && selectedTemplate.SAVEDSMSMESS_ID === "0000" ? "2px" : "1px"}
                  borderColor={
                    selectedTemplate && selectedTemplate.SAVEDSMSMESS_ID === "0000" ? "blue.400" : "gray.200"
                  }
                  bg={selectedTemplate && selectedTemplate.SAVEDSMSMESS_ID === "0000" ? "blue.50" : "gray.50"}
                  boxShadow={selectedTemplate && selectedTemplate.SAVEDSMSMESS_ID === "0000" ? "md" : "sm"}
                  cursor='pointer'
                  transition='all 0.2s'
                  _hover={{ bg: "blue.100" }}
                  onClick={() =>
                    handleTemplateSelect({
                      SAVEDSMSMESS_ID: "0000",
                      SAVEDSMSMESS_NAME: "Custom Message",
                      SAVEDSMSMESS_TEXT: "",
                    })
                  }
                >
                  <Text fontWeight='semibold' color='blue.700'>
                    Custom Message
                  </Text>
                </Box>
                {templates.map((template) => (
                  <Box
                    key={template.SAVEDSMSMESS_ID}
                    p={1}
                    borderRadius='lg'
                    borderWidth={
                      selectedTemplate && selectedTemplate.SAVEDSMSMESS_ID === template.SAVEDSMSMESS_ID ? "2px" : "1px"
                    }
                    borderColor={
                      selectedTemplate && selectedTemplate.SAVEDSMSMESS_ID === template.SAVEDSMSMESS_ID
                        ? "blue.400"
                        : "gray.200"
                    }
                    bg={
                      selectedTemplate && selectedTemplate.SAVEDSMSMESS_ID === template.SAVEDSMSMESS_ID
                        ? "blue.50"
                        : "gray.50"
                    }
                    boxShadow={
                      selectedTemplate && selectedTemplate.SAVEDSMSMESS_ID === template.SAVEDSMSMESS_ID ? "md" : "sm"
                    }
                    cursor='pointer'
                    transition='all 0.2s'
                    _hover={{ bg: "blue.100" }}
                    onClick={() => handleTemplateSelect(template)}
                  >
                    <Text fontWeight='semibold' color='blue.700'>
                      {template.SAVEDSMSMESS_NAME}
                    </Text>
                  </Box>
                ))}
              </Stack>
            ) : (
              <Text color='gray.500'>No templates available.</Text>
            )}
          </Box>
        </VStack>

        {/* Main Content */}
        <VStack w={{ base: "100%", md: "68%" }} spacing={6} align='stretch'>
          {/* Preview Card */}
          {/* <Box bg='white' p={6} borderRadius='lg' boxShadow='md' w='100%'>
            <Text fontSize='lg' fontWeight='bold' color='blue.700' mb={2}>
              Template
            </Text>
            <Box mt={2} p={4} borderWidth='1px' borderRadius='lg' w='100%' minH='100px' bg='gray.50'>
              {selectedTemplate ? (
                <div
                  style={{ color: "#2a4365", fontSize: "1rem" }}
                  dangerouslySetInnerHTML={{
                    __html: selectedTemplate.SAVEDSMSMESS_TEXT.replace(/\n/g, "<br />"),
                  }}
                />cd 
              ) : (
                <Text color='gray.500'>Select a template to preview its content.</Text>
              )}
            </Box>
          </Box> */}

          {/* Recipient Card */}
          <Box bg='gray.200' p={6} borderTopRadius='lg' boxShadow='md' w='100%'>
            <Box>
              <HStack spacing={4}>
                <Text fontSize='md' color='gray.600'>
                  Sending Message to:
                </Text>
                <Text fontSize='md' fontWeight='bold' color='blue.700'>
                  {fName + " " + sName + " - " + formatMobile(toNumber)}
                </Text>
              </HStack>
            </Box>
          </Box>

          <Box bg='white' p={6} borderBottomRadius='lg' boxShadow='md' w='100%' mt='-6' h='30vh'>
            {/* Editable Message Card */}
            {/* <Box bg='white' p={6} borderRadius='lg' boxShadow='xl' w='100%'> */}
            <Text
              as='label'
              fontSize='md'
              fontWeight='bold'
              color='blue.700'
              onClick={() =>
                handleTemplateSelect({
                  SAVEDSMSMESS_ID: "0000",
                  SAVEDSMSMESS_NAME: "Custom Message",
                  SAVEDSMSMESS_TEXT: "",
                })
              }
            >
              SMS Preview
            </Text>
            {selectedTemplate ? (
              <Textarea
                value={smsPreview}
                h='90%'
                resize='vertical'
                mt={2}
                onChange={handleInputChange}
                fontSize='md'
                borderColor='blue.300'
                focusBorderColor='blue.500'
                bg='gray.50'
              />
            ) : (
              <Text
                color='gray.500'
                onClick={() =>
                  handleTemplateSelect({
                    SAVEDSMSMESS_ID: "0000",
                    SAVEDSMSMESS_NAME: "Custom Message",
                    SAVEDSMSMESS_TEXT: "",
                  })
                }
              >
                Select a template to preview its content.
              </Text>
            )}
            {/* </Box> */}
          </Box>

          {/* Flags Card */}
          <Box bg='white' p={4} borderRadius='lg' boxShadow='md' w='100%'>
            <CheckboxGroup colorScheme='blue'>
              <HStack wrap='wrap' spacing={4}>
                <Checkbox isChecked={completeFlag} onChange={(e) => setCompleteFlag(e.target.checked)}>
                  <Text fontSize='sm'>Complete</Text>
                </Checkbox>
                <Checkbox isChecked={pickedupFlag} onChange={(e) => setPickedupFlag(e.target.checked)}>
                  <Text fontSize='sm'>Picked-Up</Text>
                </Checkbox>
                <Checkbox isChecked={irreparableFlag} onChange={(e) => setIrreparableFlag(e.target.checked)}>
                  <Text fontSize='sm'>Not Repairable</Text>
                </Checkbox>
                <Checkbox isChecked={removeFlag} onChange={(e) => setRemoveFlag(e.target.checked)}>
                  <Text fontSize='sm'>Remove</Text>
                </Checkbox>
                <Checkbox isChecked={confirmFlag} onChange={(e) => setConfirmFlag(e.target.checked)}>
                  <Text fontSize='sm'>Confirmed</Text>
                </Checkbox>
                <Checkbox isChecked={unconfirmFlag} onChange={(e) => setUnconfirmFlag(e.target.checked)}>
                  <Text fontSize='sm'>Unconfirmed</Text>
                </Checkbox>
                <Checkbox isChecked={cancelFlag} onChange={(e) => setCancelFlag(e.target.checked)}>
                  <Text fontSize='sm'>Cancel</Text>
                </Checkbox>
              </HStack>
            </CheckboxGroup>
          </Box>

          <Flex w='100%' direction={{ base: "column", md: "row" }} gap={4}>
            {/* Time delay Card */}
            <Box bg='white' p={4} borderRadius='lg' boxShadow='md' w='100%'>
              <RadioGroup onChange={setDelaySelected} value={delaySelected}>
                <Stack direction='Column' spacing={4}>
                  <Radio value='1'>Send Now</Radio>
                  <HStack>
                    <Radio value='2'>Send in ...</Radio>
                    <Input
                      type='number'
                      min='1'
                      max='999'
                      w='60px'
                      value={smsDelayMinutes}
                      onChange={(e) => setSmsDelayMinutes(e.target.value)}
                      onFocus={() => setDelaySelected("2")}
                    />
                    <Text>minutes</Text>
                  </HStack>
                  <HStack>
                    <Radio value='3'>Send at ...</Radio>
                    <Input
                      type='datetime-local'
                      w='280px'
                      value={format(smsScheduleTime, "yyyy-MM-dd'T'HH:mm")}
                      onChange={(e) => setSmsScheduleTime(new Date(e.target.value))}
                      onFocus={() => setDelaySelected("3")}
                    />
                  </HStack>
                </Stack>
              </RadioGroup>
            </Box>

            {/* Actions Card */}
            <Box
              bg='white'
              p={6}
              borderRadius='lg'
              boxShadow='xl'
              w='100%'
              display='flex'
              justifyContent='center'
              alignItems='center'
              gap={4}
            >
              <Button
                colorScheme='blue'
                size='lg'
                onClick={() => handleSendSMS()}
                disabled={
                  !selectedTemplate ||
                  smsPreview.trim() === "" ||
                  (delaySelected === "3" && new Date(smsScheduleTime) < new Date())
                }
              >
                {delaySelected === "1" && "Send SMS Now"}
                {(delaySelected === "2" || delaySelected === "3") && `Schedule SMS `}
              </Button>
              <Button colorScheme='gray' size='lg' onClick={() => navigate(-1)}>
                Cancel
              </Button>
            </Box>
          </Flex>
        </VStack>
      </Flex>
    </>
  );
};

export default SendSMSScreen;
